<template>
  <div class="expense-progress-bar-container">
    <div class="progress-bar-numbers">
      <div class="up-to-now">
        <div class="name" :class="{ 'out-of-date': outOfDate, pending }">
          <span>{{ upToNowLabel }}</span>
        </div>
        <div class="amount cashflow-type-color">
          <div v-if="isPresentingCurrentMonth && isExceedingBudget" class="icon">
            <img v-if="outOfDate" :src="require('@/assets/icons/exclemation-mark-gray.svg')">
            <img v-else :src="require('@/assets/icons/exclemation-mark-coral.svg')">
          </div>
          <template v-if="showNumber">
            <decimal-number :value="upToNowAmount"></decimal-number> ₪
          </template>
          <span v-else>{{ placeholderString }}</span>
          <span v-if="pending" class="spacer"></span>
        </div>
      </div>
      <div v-if=recommendedOrExpectedLabel class="recommended" :class="{ 'out-of-date': outOfDate, pending }">
        <div class="name">
          <span>{{ recommendedOrExpectedLabel }}</span>
        </div>
        <div class="amount">
          <template v-if="showNumber">
            <animated-decimal-number :value="recommendedOrExpectedAmount"></animated-decimal-number> ₪
          </template>
          <span v-else>{{ placeholderString }}</span>
        </div>
      </div>
    </div>
    <animated-bar :totalAmount="recommendedOrExpectedAmount" :up-to-now-amount="this.upToNowAmount" :disabled="disabled"></animated-bar>
    <div v-if="isExceedingBudget" class="exceeding-budget-warning" :class="{ 'out-of-date': outOfDate }">
      &gt;&gt;&gt; חריגה של {{ formatAmount(Math.abs(leftInBudget)) }} &lt;&lt;&lt;
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moneyUtils from '../../../../../../../../../utils/money';
import AnimatedBar from '../../../../../../../../../base-components/AnimatedBar.vue';
import AnimatedDecimalNumber from '../../../../../../../../../base-components/AnimatedDecimalNumber.vue';
import DecimalNumber from '../../../../../../../../../base-components/DecimalNumber.vue';

export default {
  name: 'ExpenseProgress',
  components: {
    AnimatedDecimalNumber,
    AnimatedBar,
    DecimalNumber,
  },
  props: {
    upToNowLabel: {
      type: String,
      required: true,
    },
    upToNowAmount: {
      type: Number,
      required: false,
    },
    recommendedOrExpectedLabel: {
      type: String,
      required: false,
    },
    recommendedOrExpectedAmount: {
      type: Number,
      required: false,
    },
    showWarningIfExceedingBudget: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    blocked: {
      type: Boolean,
      required: false,
    },
    outOfDate: {
      type: Boolean,
      required: false,
    },
    pending: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapGetters('cashflowView', ['isPresentingCurrentMonth']),
    isExceedingBudget() {
      return this.showWarningIfExceedingBudget && this.upToNowAmount > this.recommendedOrExpectedAmount;
    },
    leftInBudget() {
      return this.recommendedOrExpectedAmount - this.upToNowAmount;
    },
    showNumber() {
      return !this.disabled && !this.blocked && !this.pending;
    },
    placeholderString() {
      if (this.disabled) { return '?'; }
      if (this.blocked) { return '***'; }
      return '';
    },
  },
  methods: {
    formatAmount(amount) {
      const formattedAmount = this.disabled ? '?' : moneyUtils.formatAmountWithFraction(amount);
      return `${formattedAmount} ₪`;
    },
    isNumber(number) {
      return typeof number === 'number';
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .expense-progress-bar-container {
    margin-bottom: 20px;
    .progress-bar-numbers {
      display: flex;
      justify-content: space-between;
      font-size: 10px;
      .recommended {
        text-align: left;

        &.out-of-date {
          color: $riseup_gray_2;
        }

        &.pending {
          color: $riseup_gray_1;
        }
      }

      .name {
        line-height: 11px;

        &.out-of-date {
          color: $riseup_gray_2;
        }

        &.pending {
          color: $riseup_gray_1;
        }
      }

      .amount {
        font-weight: bold;
        font-size: 16px;
        line-height: 21px;

        .spacer {
          display: inline-block;
          height: 10px;
        }

        .icon {
          height: 13px;
          margin-left: 2px;
          display: inline-block;
          vertical-align: middle;
          margin-bottom: 5px;
        }

        .decimal {
          font-size: 10px;
        }
      }
    }

    .exceeding-budget-warning {
      font-weight: bold;
      margin-top: 4px;
      font-size: 10px;
      line-height: 10px;
      color: $riseup_coral;
      text-align: center;

      &.out-of-date {
        color: $riseup_gray_2;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue